import type { VoidFunctionComponent } from 'react';

import { useDialogContext } from '../../../contexts/DialogContext';
import { useBackfillIssueSanitizedLocators } from '../../../hooks/api/backfills/useBackfillIssueSanitizedLocators';
import Button from '../../generic/Button/Button';
import Card from '../../generic/Card/Card';
import Text from '../../generic/Text';

/**
 * Shows a button to trigger backfill issue sanitized locator data.
 */
export const BackfillIssueSanitizedLocators: VoidFunctionComponent = () => {
  const { mutate: backfillLocators, isPending } = useBackfillIssueSanitizedLocators();
  const { onConfirm } = useDialogContext();

  const onButtonClick = () => {
    onConfirm({
      title: 'Backfill Issue Sanitized Locators',
      body: (
        <div>
          are you sure you want to backfill issue sanitized locator data
        </div>
      ),
      onConfirm: async () => {
        backfillLocators();
      },
    });
  };

  return (
    <Card isFullWidth padding="medium">
      <Card.Header>Backfill Issue Sanitized Locators</Card.Header>
      <Card.Content>
        <Text.Paragraph>
          This will queue a background job that backfills data required for IssuesV2
          vulnerability &quot;Has Fix&quot; filter.
        </Text.Paragraph>
        <Button onClick={onButtonClick} isDisabled={isPending}>
          Backfill
        </Button>
      </Card.Content>
    </Card>
  );
};

export default BackfillIssueSanitizedLocators;
